import React from 'react';
import { escapeRegExp } from 'lodash';
import styled from 'styled-components';
import PropTypes from 'prop-types';

// https://stackoverflow.com/a/47803998/3882241

const Mark = styled.span`
	font-size: 10px;
	color: ${(props) => props.highlight && props.theme.colors.primary};
`;

export default function Highlighted({ text = '', highlight = '' }) {
	if (!highlight.trim()) {
		return <span>{text}</span>;
	}
	const regex = new RegExp(`(${escapeRegExp(highlight)})`, 'gi');
	const parts = text.split(regex);

	return (
		<span>
			{parts
				.filter((part) => part)
				.map((part) => (
					<Mark highlight={regex.test(part)} key={text + Math.random()}>
						{part}
					</Mark>
				))}
		</span>
	);
}

Highlighted.propTypes = {
	text: PropTypes.string,
	highlight: PropTypes.string,
};
